<template>
  <b-row>
    <b-col cols="12">
      <b-card
        body-class="d-flex flex-column justify-content-between"
        class="min-card-height"
        v-if="itemsHistInvoice[0] != undefined"
      >
        <h4 class="text-left">Histórico das Faturas</h4>
        <b-table
          :fields="fields"
          :items="itemsHistInvoice"
          :no-sort-reset="false"
          @row-clicked="seeHistoryDetails"
          borderless
          class="mb-0 pt-4 hist-invoice"
          hover
          responsive
          small
          striped
        >
          <template v-slot:cell(isPaid)="{ item }">
            <i v-bind:class="item.isPaid"></i>
          </template>

          <template v-slot:cell(isClosed)="{ item }">
            <i v-bind:class="item.isClosed"></i>
          </template>
        </b-table>
      </b-card>

      <b-card class="text-center f-g mt-2 mb-2" v-if="itemsHistInvoice[0] == undefined">
        <h4 class="text-left">Histórico das Faturas</h4>
        <i class="fa fa-hdd-o fa-custom-size mt-4"></i>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { seeHistoryDetails } from "../../assets/views/scripts/faturas/invoice_functions";

export default {
  data() {
    return {
      fields: [
        {
          key: "date",
          sortable: true,
          label: "Data",
          tdClass: "nowrap",
        },
        {
          key: "number",
          label: "Número",
          tdClass: "nowrap",
        },
        {
          key: "totalValue",
          label: "Valor Total (R$)",
          tdClass: "nowrap",
        },
        {
          key: "isPaid",
          label: "Pago",
          tdClass: "nowrap",
        },
        {
          key: "isClosed",
          label: "Fechada",
          tdClass: "nowrap",
        },
      ],
    };
  },
  props: ["itemsHistInvoice"],
  methods: {
    seeHistoryDetails,
  },
};
</script>